// UI DOM-reference map (Phase 5 module). A flat cache of getElementById refs used pervasively by
// the render/compute functions in app.js. Pure leaf — depends only on `document`. Built at module
// init (DOM is ready: the bundle loads via <script defer>). Not on window (nothing outside the
// bundle references it by bare name — verified).
export const ui = {
    accountSize: document.getElementById('accountSize'), maxRiskPct: document.getElementById('maxRiskPct'),
    atr: document.getElementById('atr'), lod: document.getElementById('lod'), entryPrice: document.getElementById('entryPrice'),
    extension: document.getElementById('extensionOutput'), distance: document.getElementById('distanceOutput'),
    mtAtrPct: document.getElementById('mtAtrPct'), mtAdrPct: document.getElementById('mtAdrPct'),
    mtAdrTier: document.getElementById('mtAdrTier'), mtAdrNote: document.getElementById('mtAdrNote'),
    mtGainMA: document.getElementById('mtGainMA'), mtLodPct: document.getElementById('mtLodPct'),
    mtAtrMult: document.getElementById('mtAtrMult'), mtExtNote: document.getElementById('mtExtNote'),
    stockSummary: document.getElementById('stockSummary'),
    stageBadge: document.getElementById('stageBadge'), stageIcon: document.getElementById('stageIcon'),
    stageIconSvg: document.getElementById('stageIconSvg'), stageLabel: document.getElementById('stageLabel'),
    stageConfidence: document.getElementById('stageConfidence'), stageVerdict: document.getElementById('stageVerdict'),
    stageDetail: document.getElementById('stageDetail'), stageMetrics: document.getElementById('stageMetrics'),
    rmvGauge: document.getElementById('rmvGauge'), rmvValue: document.getElementById('rmvValue'),
    rmvArrow: document.getElementById('rmvArrow'), rmvBand: document.getElementById('rmvBand'),
    rmvFill: document.getElementById('rmvFill'), rmvMarker: document.getElementById('rmvMarker'),
    rmvNote: document.getElementById('rmvNote'),
    growthStatus: document.getElementById('growthStatus'), growthVerdict: document.getElementById('growthVerdict'),
    epsAccelVal: document.getElementById('epsAccelVal'), epsAccelBand: document.getElementById('epsAccelBand'), epsAccelFill: document.getElementById('epsAccelFill'),
    salesAccelVal: document.getElementById('salesAccelVal'), salesAccelBand: document.getElementById('salesAccelBand'), salesAccelFill: document.getElementById('salesAccelFill'),
    growthTableBody: document.getElementById('growthTableBody'),
    sumHeadline: document.getElementById('sumHeadline'),
    shares: document.getElementById('sharesOutput'), risk: document.getElementById('riskOutput'),
    positionSize: document.getElementById('positionSizeOutput'), portfolioPct: document.getElementById('portfolioPctOutput'),

    bpWarn: document.getElementById('bpWarning'), extWarn: document.getElementById('extensionWarning'), stopWarn: document.getElementById('stopWarning'),
    tickerInput: document.getElementById('tickerInput'), btn: document.getElementById('fetchBtn'), status: document.getElementById('fetchStatus'),
    apiKey: document.getElementById('apiKeyInput'),

    dist9: document.getElementById('dist9'), status9: document.getElementById('status9'), card9: document.getElementById('card9'),
    dist21: document.getElementById('dist21'), status21: document.getElementById('status21'), card21: document.getElementById('card21'),
    dist50: document.getElementById('dist50'), status50: document.getElementById('status50'), card50: document.getElementById('card50'),
    dist200: document.getElementById('dist200'), status200: document.getElementById('status200'), card200: document.getElementById('card200'),

    pct1d: document.getElementById('pct1d'), pct1w: document.getElementById('pct1w'),
    pct1m: document.getElementById('pct1m'), pct3m: document.getElementById('pct3m'), pct6m: document.getElementById('pct6m'), pctYtd: document.getElementById('pctYtd'),
    rvolValue: document.getElementById('rvolValue'), currentVol: document.getElementById('currentVol'), avgVol: document.getElementById('avgVol'), rvolStatus: document.getElementById('rvolStatus'),

    minScore: document.getElementById('minerviniScore'), minVerdict: document.getElementById('minerviniVerdict'),
    fdLastPrice: document.getElementById('fdLastPrice'), fdMktCap: document.getElementById('fdMktCap'),
    fdSector: document.getElementById('fdSector'), fdIndustryGroup: document.getElementById('fdIndustryGroup'),
    fdGroupRank: document.getElementById('fdGroupRank'), fdIndustry: document.getElementById('fdIndustry'),
    fdShares: document.getElementById('fdShares'), fdRvol20: document.getElementById('fdRvol20'), fdAvgVol50: document.getElementById('fdAvgVol50'),
    fdAvgDolVol50: document.getElementById('fdAvgDolVol50'), fdDayRange: document.getElementById('fdDayRange'),
    fdWeekRange: document.getElementById('fdWeekRange'), fd52High: document.getElementById('fd52High'),
    fd52Low: document.getElementById('fd52Low'), fdFromHigh: document.getElementById('fdFromHigh'), fdFromLow: document.getElementById('fdFromLow'),

    wedgeSignal: document.getElementById('wedgeSignal'),
    channelGauge: document.getElementById('channelGauge'), omegaSignal: document.getElementById('omegaSignal'),

    benchStatus: document.getElementById('benchStatus'), indexCardsContainer: document.getElementById('indexCardsContainer'),
    scanStatusText: document.getElementById('scanStatusText'),
    scanCountText: document.getElementById('scanCountText'), scanProgressBar: document.getElementById('scanProgressBar'),
    top10Table: document.getElementById('top10Table'), bottom20Table: document.getElementById('bottom20Table'),

    // Conviction Engine Elements
    convictionPanel: document.getElementById('convictionPanel'),
    tierStockBadge: document.getElementById('tierStockBadge'),
    tierGroupBadge: document.getElementById('tierGroupBadge'),
    tierCompany: document.getElementById('tierCompany'),
    tierName: document.getElementById('tierName'),
    tierAction: document.getElementById('tierAction'),
    scStruct: document.getElementById('scStruct'),
    scLiq: document.getElementById('scLiq'),
    scGeom: document.getElementById('scGeom'),
    scoreValue: document.getElementById('scoreValue'),
    scoreCircle: document.getElementById('scoreCircle'),

    marketScreenerToggle: document.getElementById('marketScreenerToggle'),
    marketScreenerPanel: document.getElementById('marketScreenerPanel'),
    marketScreenerClose: document.getElementById('marketScreenerClose'),
    screenerResizeHandle: document.getElementById('screenerResizeHandle'),
    paramsResizeHandle: document.getElementById('paramsResizeHandle'),
    screenerAutoStatus: document.getElementById('screenerAutoStatus'),
    scrMinPrice: document.getElementById('scrMinPrice'),
    scrMinAvgVol: document.getElementById('scrMinAvgVol'),
    scrMaxDeep: document.getElementById('scrMaxDeep'),
    scrMinScore: document.getElementById('scrMinScore'),
    scrMaxRmv: document.getElementById('scrMaxRmv'),
    scrMinBqs: document.getElementById('scrMinBqs'),
    scrSignalFilter: document.getElementById('scrSignalFilter'),
    scrTierFilter: document.getElementById('scrTierFilter'),
    scrStageFilter: document.getElementById('scrStageFilter'),
    scrChannelFilter: document.getElementById('scrChannelFilter'),
    scrOmegaFilter: document.getElementById('scrOmegaFilter'),
    scrSectorFilter: document.getElementById('scrSectorFilter'),
    scrGroupFilter: document.getElementById('scrGroupFilter'),
    scrMaxGroupRank: document.getElementById('scrMaxGroupRank'),
    scrRmvZoneFilter: document.getElementById('scrRmvZoneFilter'),
    scrVolumeSignalFilter: document.getElementById('scrVolumeSignalFilter'),
    scrExtensionFilter: document.getElementById('scrExtensionFilter'),
    scrEpsAccelFilter: document.getElementById('scrEpsAccelFilter'),
    scrSalesAccelFilter: document.getElementById('scrSalesAccelFilter'),
    scrGrowthFilter: document.getElementById('scrGrowthFilter'),
    scrMinDollarVol: document.getElementById('scrMinDollarVol'),
    scrMinRvol: document.getElementById('scrMinRvol'),
    scrMinPerf1d: document.getElementById('scrMinPerf1d'),
    scrMinPerf1w: document.getElementById('scrMinPerf1w'),
    scrMinPerf1m: document.getElementById('scrMinPerf1m'),
    scrMinPerf3m: document.getElementById('scrMinPerf3m'),
    scrMinPerf6m: document.getElementById('scrMinPerf6m'),
    scrMinPerf12m: document.getElementById('scrMinPerf12m'),
    scrMinRsi: document.getElementById('scrMinRsi'),
    scrMaxRsi: document.getElementById('scrMaxRsi'),
    scrMinMv: document.getElementById('scrMinMv'),
    scrMin9ema: document.getElementById('scrMin9ema'),
    scrMax9ema: document.getElementById('scrMax9ema'),
    scrMin21ema: document.getElementById('scrMin21ema'),
    scrMax21ema: document.getElementById('scrMax21ema'),
    scrMin50sma: document.getElementById('scrMin50sma'),
    scrMax50sma: document.getElementById('scrMax50sma'),
    scrMin200sma: document.getElementById('scrMin200sma'),
    scrMax200sma: document.getElementById('scrMax200sma'),
    scrVcpFilter: document.getElementById('scrVcpFilter'),
    scrRsnhFilter: document.getElementById('scrRsnhFilter'),
    scrLeadershipFilter: document.getElementById('scrLeadershipFilter'),
    scrMinAdr: document.getElementById('scrMinAdr'),
    scrMaxAdr: document.getElementById('scrMaxAdr'),
    scrMinTrend: document.getElementById('scrMinTrend'),
    scrMinDemand: document.getElementById('scrMinDemand'),
    scrMinTiming: document.getElementById('scrMinTiming'),
    screenerPresetChips: document.getElementById('screenerPresetChips'),
    screenerStatusText: document.getElementById('screenerStatusText'),
    screenerThrottle: document.getElementById('screenerThrottle'),
    screenerCountText: document.getElementById('screenerCountText'),
    screenerProgressBar: document.getElementById('screenerProgressBar'),
    scrStatUniverse: document.getElementById('scrStatUniverse'),
    scrStatScanned: document.getElementById('scrStatScanned'),
    scrStatMatches: document.getElementById('scrStatMatches'),
    scrStatBest: document.getElementById('scrStatBest'),
    screenerResultsBody: document.getElementById('screenerResultsBody')
};
